import queryString from 'query-string';
import { deleteProfileCookies } from '../userLocalDetails';
import { getLtiCodeFromUrl } from './ltiEmbedded';

/**
 * The URL parameters App.jsx's auth bootstrap reads: the search string merged
 * over the hash route's query (HashRouter keeps routes in the hash).
 */
export const readAuthUrlParams = () => {
  const parsedFromSearch = queryString.parse(window.location.search);
  const parsedFromHash = window.location.hash.includes('?')
    ? queryString.parse(window.location.hash.split('?')[1])
    : {};
  return { ...parsedFromHash, ...parsedFromSearch };
};

/**
 * True when the URL carries a one-time login credential that App.jsx
 * exchanges for a new session: a WordPress `sso_token`, an LTI `lti_code`, or
 * a legacy `code`. Same conditions as the exchange branches in App.jsx.
 */
export const hasIncomingLoginCredential = () => {
  const parsed = readAuthUrlParams();
  return Boolean(
    parsed.sso_token || parsed.lti_code || getLtiCodeFromUrl() || parsed.code
  );
};

/**
 * Run once before the app mounts. A login credential in the URL means someone
 * is signing in, possibly as a different account from the one this browser
 * still holds (the previous user logged out of WordPress but not the app, or
 * just closed the tab). Until the exchange finished, the old JWT and userId
 * were still used: TourProvider fetched the old user's profile, App rendered
 * it beside the new user's role, and onboarding redirects meant for the old
 * account fought the new account's route guards (an endless
 * / ↔ /student-onboarding redirect and a blank page). Dropping the old
 * identity first makes an account switch start exactly like a login in a
 * fresh tab. Only the session identity goes (deleteProfileCookies); per-user
 * and device preferences stay.
 *
 * Returns true when the URL carried a credential (any stored session is gone).
 */
export const dropSessionSupersededByIncomingLogin = () => {
  try {
    if (!hasIncomingLoginCredential()) return false;
    deleteProfileCookies();
    return true;
  } catch (e) {
    // Never block boot; the exchange in App.jsx still replaces the session.
    return false;
  }
};
